
export const EXPECTED_EVENTS = ['DocumentAttached', 'CallEmittedTo', 'CallReceived', 'AssigneeIdentified', 'InterventionDeadlineDefined', 'FormalNoticeForProviderReported', 'SendingServiceOrderReported',
    'CallAnsweredByProvider', 'CallNotAnsweredByProvider', 'InterventionScheduled', 'InterventionRequested', 'InterventionAccepted', 'InterventionRefused', 'ArrivedOnSite', 'GoneFromSite', 'InterventionStarted', 
    'InterventionFinished', 'MissionFinished', 'TicketCancelled', 'TicketClosed', 'TicketArchived', 'PermanentlyFixed', 'PartiallyFixed',
    'TicketClosedImpossibleRepair', 'PostponedFix', 'ClosedBeyondCallCenterScope', 'ClosedAfterSeveralUnsuccessfulRecalls']

export const ACTORS = ['Executive', 'PatrimonyManager', 'CallCenterOperator']

export const STEP_TIME_LIMIT_TYPE = ['DurationAfterPreviousStep']

export const NEW_WORKFLOW = {
    identifiedRequests: [],
    steps: []
}

export class TodoCriteria {
}

TodoCriteria.schema = {
    type: 'object',
    properties: {
        agency: {type: 'array'},
        clientCompany: {type: 'array'},
        expectedCommand: {type: 'array'},
        operator: {type: 'array'},
        actor: {type: 'array'},
        expectedDateStart: {type: 'string'},
        expectedDateEnd: {type: 'string'}
    }
}

export class CreateWorkflowAction {
}

CreateWorkflowAction.schema = {
    type: 'object',
    properties: {
        label: {type: 'string'}
    },
    required: ['label']
}

export class UpdateWorkflowLabelAction {
}

UpdateWorkflowLabelAction.schema = {
    type: 'object',
    properties: {
        label: {type: 'string'}
    },
    required: ['label']
}

export class UpdateIdentifiedRequestsAction {
}

UpdateIdentifiedRequestsAction.schema = {
    type: 'object',
    properties: {
        identifiedRequests: {type: 'array'}
    },
    required: ['identifiedRequests']
}

export class AddStepAction {
}

AddStepAction.schema = {
    type: 'object',
    properties: {
        step: {
            type: 'object',
            properties: {
                expectedEvent: {type: 'string'},
                actors: {
                    type: 'array',
                    minItems: 1
                },
                order: {type: 'integer'},
                timeLimit: {
                    type: ['object', 'null'],
                    properties: {
                        duration: {type: 'integer'},
                        workflowStepTimeLimitType: {type: 'string'}
                    },
                    required: ['duration', 'workflowStepTimeLimitType']
                }
            },
            required: ['expectedEvent', 'actors', 'order']
        }
    },
    required: ['step']
}

export class UpdateStepAction {
}

UpdateStepAction.schema = {
    type: 'object',
    properties: {
        step: {
            type: 'object',
            properties: {
                expectedEvent: {type: 'string'},
                actors: {
                    type: 'array',
                    minItems: 1
                },
                order: {type: 'integer'},
                timeLimit: {
                    type: ['object', 'null'],
                    properties: {
                        duration: {type: 'integer'},
                        workflowStepTimeLimitType: {type: 'string'}
                    },
                    required: ['duration', 'workflowStepTimeLimitType']
                }
            },
            required: ['expectedEvent', 'actors', 'order']
        }
    },
    required: ['step']
}


// WEBPACK FOOTER //
// ./lib/workflow/models.js